"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { TierPreview } from "@/components/tier-preview";
import { Trash2 } from "lucide-react";
import { TierItem } from "@/components/sortable-tier-item";

interface TierItemContentProps {
  tier: TierItem;
  index: number;
  onLabelChange?: (index: number, label: string) => void;
  openColorModal?: (index: number) => void;
  removeTier?: (index: number) => void;
  tiersLength: number;
  readOnly?: boolean;
}

export function TierItemContent({
  tier,
  index,
  onLabelChange,
  openColorModal,
  removeTier,
  tiersLength,
  readOnly = false,
}: TierItemContentProps) {
  return (
    <>
      <Input
        placeholder="Tier Label"
        value={tier.label}
        onChange={
          onLabelChange && !readOnly
            ? (e) => onLabelChange(index, e.target.value)
            : undefined
        }
        readOnly={readOnly}
      />

      <TierPreview
        labelColor={tier.labelColor}
        backgroundColor={tier.backgroundColor}
        onClick={openColorModal && !readOnly ? () => openColorModal(index) : undefined}
      />

      <Button
        type="button"
        variant="destructive"
        size="icon"
        onClick={removeTier && !readOnly ? () => removeTier(index) : undefined}
        disabled={tiersLength <= 1 || readOnly}
        className="shrink-0"
      >
        <Trash2 className="w-4 h-4" />
      </Button>
    </>
  );
}
